// extracted by mini-css-extract-plugin
export default {"select":"MinorSelect_select__rs8aU","selectItem":"MinorSelect_selectItem__EY0Iy"};